import {createSelector} from '@reduxjs/toolkit';

import {UIState} from '.';
import {AppState} from '..';

export const uiSelector = (state: AppState): UIState => state.ui;

export const isLogoExpandedSelector = createSelector(
  uiSelector,
  state => state.isLogoExpanded
);
